import { Box, styled } from '@mui/material'
import { SelectMenu } from '$common/select-menu'
import { NavigationBarVideoIcon } from '$common/icons/navitation-bar-tool-box/video'
import { NavigationBarFilmIcon } from '$common/icons/navitation-bar-tool-box/film'
import { NavigationBarMusicIcon } from '$common/icons/navitation-bar-tool-box/music'
import { NavigationBarVoiceIcon } from '$common/icons/navitation-bar-tool-box/voice'
import { NavigationBarImageIcon } from '$common/icons/navitation-bar-tool-box/image'
import { NavigationBarBookIcon } from '$common/icons/navitation-bar-tool-box/book'
import { NavigationBarAppIcon } from '$common/icons/navitation-bar-tool-box/apps'
import { NavigationBarOtherIcon } from '$common/icons/navitation-bar-tool-box/others'
import { useWindowHeight } from '$func/window.react-hook'
import { closeNavbarToolBox } from '$logic/router'
import {
  MULTIMEDIA_TYPES,
  MultimediaLabelType,
  openMultimediaCreator,
} from '$logic/wapps/business'
import { ArrowRightIcon } from '$common/icons'
import { t } from '$i18n'

const StyledBox = styled(Box)({
  width: '40px',
  height: '40px',
  backgroundColor: '#E8E9FC',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '10px',
  borderRadius: '50%',
})

const getIcons = async () => {
  return [
    <NavigationBarVideoIcon />,
    <NavigationBarFilmIcon />,
    <NavigationBarMusicIcon />,
    <NavigationBarVoiceIcon />,
    <NavigationBarImageIcon />,
    <NavigationBarBookIcon />,
    <NavigationBarAppIcon />,
    <NavigationBarOtherIcon />,
  ].map((icon, index) => <StyledBox key={index}>{icon}</StyledBox>)
}
export function CulturalContentsSelectMenu({
  onBack,
}: {
  onBack: () => unknown
}) {
  const windowHeight = useWindowHeight()
  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <SelectMenu
        onDone={async ([contentType]) => {
          await closeNavbarToolBox()

          const type = MULTIMEDIA_TYPES[contentType as MultimediaLabelType]
          openMultimediaCreator(type)
        }}
        headerTexts={[t('wapps.multimedia')]}
        HeaderIcon={ArrowRightIcon}
        onExit={onBack}
        alignOptionsCenter={false}
        optionFetchers={[async () => Object.keys(MULTIMEDIA_TYPES)]}
        iconFetchers={[getIcons]}
        maxHeight={windowHeight}
      />
    </Box>
  )
}
